// src/components/content/ClientHomeWrapper.tsx

"use client"

import { type ReactNode } from "react"
import { ScrollProvider } from "~/components/ScrollContext"

export function ClientHomeWrapper({ children }: { children: ReactNode }): JSX.Element {
  return (
    <ScrollProvider>
      {children}
    </ScrollProvider>
  )
}